import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
declare const NanoPlayer: any;

@Component({
    selector: 'app-nano-player',
    imports: [CommonModule],
    templateUrl: './nano-player.component.html',
    styleUrl: './nano-player.component.scss'
})
export class NanoPlayerComponent implements AfterViewInit, OnDestroy {
    @Input()
    config?: object;

    @Output()
    readonly toggleClicked = new EventEmitter<void>();

    private nanoPlayer: unknown;

    ngAfterViewInit(): void {
        if (!this.config) {
            // eslint-disable-next-line no-console
            console.error('config not provided');
            return;
        }

        this.initPlayer(this.config);
    }

    ngOnDestroy(): void {
        if (this.nanoPlayer) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-call
            (this.nanoPlayer as any).destroy();
        }
    }

    private initPlayer(config: object): void {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-assignment
        const player = new NanoPlayer('player');

        // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-explicit-any
        (player.setup(config) as Promise<any>).then(
            (finalConfig) => {
                // eslint-disable-next-line @typescript-eslint/no-magic-numbers,no-console
                console.log(`NanoPlayer setup succeeded with config: ${JSON.stringify(finalConfig, undefined, 4)}`);
                this.nanoPlayer = player;
            },
            (error) => {
                // eslint-disable-next-line no-console
                console.log('NanoPlayer setup failed', error);
            }
        );
    }
}
